import { useAuth } from "../Components/context/Auth";
import { API_DOMENS, BASE_API_PAGE_ENUMS, BASE_API_ROUTES } from "../constants/apis.constants";
import { getAPIData, IndependentGetAPIData } from "../Utils/commonApi";
import { updateAccessKeyInLocalStorage } from "../Utils/CommonFunctions copy";
import userUtils from "../Utils/user.utils";
import useBaseActions from "./actions/base.actions";


const useApiActions = () => {
  const { authTokens } = useAuth();
  const { onError, onSuccess } = useBaseActions();

  const getAllIntegrationsByTechType = async ({ 
    technologyTypeEnum, 
    showAll = false,
    searchText = '',
  }) => {
    try {
      const message = userUtils.getUserMessage();
      const formData = new FormData();
      formData.append('TechnologyTypeEnum', technologyTypeEnum);
      formData.append('ShowAll', showAll);
      formData.append('Search_text', searchText);
      formData.append('accessKey', message);
      return fetch(
        BASE_API_ROUTES.getAllIntegrationsByTechType,
        {
          method: "POST",
          body: formData,
          headers: {
            Authorization: `Bearer ${authTokens}`,
          },
        }
      ).then((response) => response.json());
    } catch (error) {
      console.error('Error fetching integrations', error);
    }
  }

  const createTaxRate = async ({ ObjectId, TaxCode, TaxName, TaxRate, IsDefault, IsDisabled }) => {
    try {
      const message = userUtils.getUserMessage();
      const formData = new FormData();
      formData.append('ObjectId', ObjectId);
      formData.append('TaxName', TaxName);
      formData.append('TaxRate', TaxRate);
      formData.append('TaxCode', TaxCode);
      formData.append('IsDefault', IsDefault);
      formData.append('isDisabled', IsDisabled);
      formData.append('AccessKey', message);
      return fetch(
        BASE_API_ROUTES.createTaxRate,
        {
          method: "POST",
          body: formData,
          headers: {
            Authorization: `Bearer ${authTokens}`,
          },
        }   
      ).then((response) => response.json())
      .then((response) => {
        if (response?.Success) {
          onSuccess();
        } else {
          onError();
        }
        return response;
      } );
    } catch (error) {
      console.error('Error creating tax rate', error);
    }
  }

  const submitQuestionNote = ({ noteValue, technologyEnum, clientId }) => {
    return getAPIData(BASE_API_PAGE_ENUMS.QuestionNote, authTokens, {
     OptionEnum1: technologyEnum,
     optionEnum1: technologyEnum,
     ...(clientId && {
       optionEnum2: clientId,
     }, API_DOMENS.CC_API),
     ...(typeof noteValue === 'string' && {
       optionStrEnum1: noteValue,
     })
   }).then((response) => {
     if (response?.mr?.Success < 400) {
       if (response?.mr?.Message) {
         updateAccessKeyInLocalStorage(response.mr.Message);
       }
       // onSuccess();
     } else {
       onError();
     }
   });
  }

  const updateToolToYes = async ({ technologyEnum }) => {
    return getAPIData(BASE_API_PAGE_ENUMS.ToolToYes, authTokens, {
      optionEnum1: technologyEnum,
    }).then((response) => {
      if (response?.mr?.Success < 400) {
        if (response?.mr?.Message) {
          updateAccessKeyInLocalStorage(response.mr.Message);
        }
        onSuccess();
      } else {
        onError();
      }
    });
  }

  const checkToolInUse = async ({ integrationId }) => {
    return getAPIData(BASE_API_PAGE_ENUMS.CheckToolInUse, authTokens, {
      optionEnum1: integrationId,
    });
  }

  const removeIntegration = async ({ integrationId, technologyEnum }) => {
    return IndependentGetAPIData(BASE_API_PAGE_ENUMS.RemoveIntegration, authTokens, {
      optionEnum1: integrationId,
      optionEnum3: technologyEnum,
    }).then((response) => {
      if (response?.Success) {
        onSuccess();
      } else {
        onError();
      }
    });
  }

  const deleteIntegration = async ({ integrationId }) => {
    return IndependentGetAPIData(BASE_API_PAGE_ENUMS.DeleteIntegration, authTokens, {
      optionEnum1: integrationId,
      optionEnum2: 0
    }).then((response) => {
      if (response?.Success) {
        onSuccess();
      } else {
        onError();
      }
    });
  }

  return {
    createTaxRate,
    submitQuestionNote,
    updateToolToYes,
    checkToolInUse,
    removeIntegration,
    deleteIntegration,
    getAllIntegrationsByTechType,
  }
}

export default useApiActions;
